import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
    size: { default: 32 }
  },
  setup(__props: any) {

const props = __props as { size: number };



const style = computed(() => ({ transformOrigin: `${props.size}px ${props.size}px` }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sem is-sem parent set-position--relative",
    style: _normalizeStyle({ '--size': __props.size, width: __props.size + 'px', height: __props.size + 'px' })
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(style))
    }, null, 4),
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(style))
    }, null, 4),
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(style))
    }, null, 4),
    _createElementVNode("div", {
      style: _normalizeStyle(_unref(style))
    }, null, 4)
  ], 4))
}
}

})